import { Map as ImmutableMap } from 'immutable';
import { FetchCanGdprDeleteSelfActionTypes } from '../actions/UserCanGdprDeleteSelfActions';
import { handleActions } from 'flux-actions';
const initialState = ImmutableMap({
  singleSuperAdminHubs: []
});
export default handleActions({
  [FetchCanGdprDeleteSelfActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.set('singleSuperAdminHubs', action.payload.data);
  }
}, initialState);